import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { PushOrderFormFields } from '../helpers';

export const usePushOrderFormRules = () => {
  const { t } = useTranslation();
  const required = useGetRequiredRule({ t });

  return {
    [PushOrderFormFields.ORDER_ID]: [required],
  };
};
